import React from 'react'
import { SvgIcon } from '../svg-icon'

import styles from './parking-position-icon.module.css'
/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <...Icon width={12} />
 */
const ParkingPositionIcon = props => (
    <SvgIcon {...props} className={styles['parking-position-pin']}>
        <path
            className={styles['icon-foreground']}
            d={`M37.528 7.876a19.117 19.117 0 0 0-13.51-5.56A19.107 19.107 0 0
                0 10.503 7.88a18.863 18.863 0 0 0-5.598 13.43c0 5.244 2.144 9.994 5.603 13.432C13.968 38.18 24.018 46
                24.018 46S34.07 38.177 37.53 34.74c3.46-3.44 5.598-8.187 5.598-13.432 0-5.245-2.14-9.994-5.6-13.432`}
        />
        <path
            className={styles['icon-background']}
            d={`M36.627 8.81a17.84 17.84 0 0 0-12.61-5.19 17.84 17.84 0 0
                0-12.614 5.193 17.616 17.616 0 0 0-5.225 12.535c0 4.896 2 9.33 5.23 12.54 3.228 3.206 12.608 10.505
                12.608 10.505s9.384-7.3 12.613-10.51c3.225-3.21 5.222-7.64 5.222-12.535
                0-4.896-1.997-9.328-5.227-12.537`}
        />
        <path
            className={styles['icon-foreground']}
            d={`M26.73 11.472h-9.78v20.514h5.587v-6.774h4.193c3.846 0 6.96-3.08
                6.96-6.865 0-3.797-3.114-6.875-6.96-6.875zm-1.162 9.434c-1.042 0-3.02-.01-3.02-.01v-5.672h3.02c1.777 0
                3.22 1.283 3.22 2.875 0 1.573-1.443 2.804-3.22 2.804z`}
        />
    </SvgIcon>
)

ParkingPositionIcon.defaultProps = defaultProps

export { ParkingPositionIcon }
